// extracted by mini-css-extract-plugin
export default {"summary":"style_summary__CwPGX","text":"style_text__ou6PQ","xerc":"style_xerc__qfAyi","incomme":"style_incomme__YGVLI","down":"style_down__CrjfP","accSum":"style_accSum__777dx"};